import { ActiveCampaign } from 'modules/campaigns/types'
import { pathOr } from 'ramda'
import { useSelector } from 'react-redux'

const activeCampaignSelector = state => pathOr<ActiveCampaign>(null, ['campaigns', 'activeCampaign'], state)

const useActiveCampaign: (() => ActiveCampaign) = () =>
  useSelector(activeCampaignSelector)

export default useActiveCampaign
